import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { State } from './core.state';

import * as UserReducer from './session/session.reducer';
import * as ErrorReducer from './error/error.reducer';
import * as ProjectsReducer from '../project/store/reducers';
import * as AutomationLoadsReducer from 'app/broker/automation/loads/store/reducers';
import * as AutomationTransactionsReducer from 'app/broker/automation/transactions/store/reducers';
import * as AutomationRFPsReducer from 'app/broker/automation/rfp/store/reducers';
import * as BookingAssistantReducers from 'app/broker/automation/booking-assistant-automation/store/reducers';
import * as LoadsSourcesReducers from 'app/loads-sourcing/store/reducers';
import * as ProjectDetailsReducers from 'app/project/store/reducers';
import * as LoadsListsReducers from 'app/v2/loads/store/reducers';
import * as CarrierLanesReducers from 'app/carriers/lanes/store/reducers';
import * as ProcurementReducers from 'app/v2/procurement/store/reducers';
import * as WorkflowsReducers from 'app/v2/workflows/store/reducers';
import * as CarrierNetworkReducers from 'app/carriers/network/store/reducers';
import * as TeamsReducers from 'app/broker/teams/store/reducers';

import { localStorageSync, rehydrateApplicationState } from 'ngrx-store-localstorage';
import { SessionActions, sessionStateKey } from '@state/session';
import { errorStateKey } from '@state/error';
import { projectsPageStateKey } from '../project/store/state';
import { automationLoadsPageStateKey } from 'app/broker/automation/loads/store/state';
import { automationTransactionsPageStateKey } from 'app/broker/automation/transactions/store/state';
import { automationRFPPageStateKey } from 'app/broker/automation/rfp/store/state';
import { bookingAssistantAutomationPageStateKey } from 'app/broker/automation/booking-assistant-automation/store/state';
import { loadsSourcingPageStateKey } from 'app/loads-sourcing/store/state';
import { projectDetailsPageStateKey } from 'app/project/store/state';
import { loadsPageStateKey } from 'app/v2/loads/store/state';
import { carrierLanesPageStateKey } from 'app/carriers/lanes/store/state';
import { procurementPageStateKey } from 'app/v2/procurement/store/state';
import { workflowsPageStateKey } from 'app/v2/workflows/store/state';
import { carrierNetworkPageStateKey } from 'app/carriers/network/store/state';
import { teamsPageStateKey } from 'app/broker/teams/store/state';

export const reducers: ActionReducerMap<State> = {
	[sessionStateKey]: UserReducer.reducer,
	[errorStateKey]: ErrorReducer.reducer,
	[projectsPageStateKey]: ProjectsReducer.reducers,
	[automationLoadsPageStateKey]: AutomationLoadsReducer.reducers,
	[automationTransactionsPageStateKey]: AutomationTransactionsReducer.reducers,
	[automationRFPPageStateKey]: AutomationRFPsReducer.reducers,
	[bookingAssistantAutomationPageStateKey]: BookingAssistantReducers.reducers,
	[loadsSourcingPageStateKey]: LoadsSourcesReducers.reducers,
	[projectDetailsPageStateKey]: ProjectDetailsReducers.reducers,
	[loadsPageStateKey]: LoadsListsReducers.reducers,
	[carrierLanesPageStateKey]: CarrierLanesReducers.reducers,
	[procurementPageStateKey]: ProcurementReducers.reducers,
	[workflowsPageStateKey]: WorkflowsReducers.reducers,
	[carrierNetworkPageStateKey]: CarrierNetworkReducers.reducers,
	[teamsPageStateKey]: TeamsReducers.reducers,
};

function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
	return (state: State, action: any) => {
		const keys = [sessionStateKey];

		if (action.type === SessionActions.storage.update.type) {
			return { ...state, ...rehydrateApplicationState(keys, localStorage, (k) => k, false) };
		}

		return localStorageSync({
			keys,
			rehydrate: true,
			restoreDates: false,
		})(reducer)(state, action);
	};
}

export const metaReducers: MetaReducer<State>[] = [localStorageSyncReducer];
